import { render, staticRenderFns } from "./DebugView.vue?vue&type=template&id=4ccb1999&scoped=true"
import script from "./DebugView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DebugView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DebugView.vue?vue&type=style&index=0&id=4ccb1999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb1999",
  null
  
)

export default component.exports